import { interpolate } from './interpolate';

/**
 * Nunjucks is passing the options arguments into args as a dictionary (for whatever reason)
 */
/* eslint-disable complexity */
export function getTranslation(slug, args) {
    const container = _.get(args, 'container');
    const state = _.get(args, 'state');
    const params = _.get(args, 'params');
    const defaultSlug = _.get(args, 'defaultSlug');
    const orEmpty = _.get(args, 'orEmpty');

    const c = state || this.ctx.core;
    const slugOrEmpty = orEmpty ? '' : `{${slug}}`;

    if (!c) {
        return slugOrEmpty;
    }

    if (!slug) {
        return '';
    }

    const localizations = _.get(c, 'localizations');
    const defaultContainer = _.get(localizations, 'defaultContainer');
    const containers = _.get(localizations, 'containers');

    if (!localizations || !defaultContainer || !containers) {
        return slugOrEmpty;
    }

    const i = container || defaultContainer;

    if (!containers || !i) {
        return slugOrEmpty;
    }

    const targetContainer = containers[i];

    if (!targetContainer) {
        return slugOrEmpty;
    }

    const stringSlug = slug.toString().trim();

    let translatedText = '';

    if (defaultSlug && !targetContainer[stringSlug]) {
        translatedText = `${targetContainer[defaultSlug]}`.trim();
    } else if (targetContainer[stringSlug]) {
        translatedText = `${targetContainer[stringSlug]}`.trim();
    } else {
        return slugOrEmpty;
    }

    if (params && params.length > 0) {
        return interpolate(translatedText, params);
    }

    return translatedText;
}

export function errorTranslation(slug, args) {
    const container = _.get(args, 'container', 'errorLocalization');
    const state = _.get(args, 'state');
    const params = _.get(args, 'params');
    const t = this.env.globals.t.bind(this);

    return t(slug, { container: container, state: state, params: params });
}
